import { createContext, ReactNode, useContext } from "react";
import { useLoaderData } from "react-router";

import { PortfolioData } from "../App.tsx";
import { PortfolioStats } from "../shared/PortfolioTypes.ts";

export const PortfolioContext = createContext<PortfolioStats | null>(null);

export const usePortfolio = () => {
  const context = useContext(PortfolioContext);
  if (!context) {
    throw new Error("usePortfolio must be used within a PortfolioProvider");
  }
  return context;
};

export const PortfolioProvider = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const { stats } = useLoaderData() as PortfolioData;
  return (
    <PortfolioContext.Provider value={stats}>
      {children}
    </PortfolioContext.Provider>
  );
};
